
/* ============================================================
   LASTING LOVER — NECKLACE GEOMETRY

   Geometria condivisa tra:
   - Configuratore collana
   - Pagina anteprima
   - Carrello

   CATENE:
   - maxi = collana con anelli grandi
   - mini = collana con catena fine

   CATENA MINI:
   - Ciondoli ingranditi
   - Distanza ravvicinata
   - Sovrapposizione consentita
   - Aggancio automatico basato sulla trasparenza PNG

   Le impostazioni MAXI rimangono invariate.
   ============================================================ */

window.LLNecklace = (function () {
  "use strict";

  /* ==========================================================
     PRESET DELLE CATENE
     ========================================================== */

  var PRESETS = {
    maxi: {
      centerX: 50,
      centerY: 80.5,
      curveA: 0.00076,
      curveB: 0.0000414,
      linkPitch: 4.0,
      linksBetween: 3,
      charmWidth: 11,
      charmWidthM: 13,
      tilt: 0.35,
      isMini: false
    },

    mini: {
      centerX: 50,
      centerY: 85,
      curveA: 0.01676,
      curveB: 0.00000405,
      linkPitch: 2.2,
      linksBetween: 3,
      charmWidth: 10,
      charmWidthM: 12,
      tilt: 0.35,
      isMini: true
    }
  };

  /* ==========================================================
     DIMENSIONI CIONDOLI
     ========================================================== */

  var NEW_CHARM_SCALE = 0.55;

  var MINI_NEW_SCALE = 3.30;
  var MINI_ORIGINAL_SCALE = 2.10;

  var MINI_CHARM_LIFT = 2.5;

  /* ==========================================================
     COLORE CIONDOLI NORMALI
     ========================================================== */

  var NORMAL_CHARM_FILTER =
    "saturate(0.65) brightness(1.08)";

  /* ==========================================================
     ELENCO DEI 14 NUOVI CIONDOLI
     ========================================================== */

  var NEW_CHARMS = [
    "Cuore in madreperla",
    "Cuore dorato perlato",
    "Cuore bianco smaltato",
    "Cuore con anello centrale",
    "Cuore con bordo intrecciato",
    "Cuore con battito e strass",
    "Cuore rosso smaltato",
    "Cuore rosa con tulipano",
    "Fiore blu",
    "Lavanda",
    "Ciliegie rosse",
    "Fragola",
    "Fiocco blu",
    "Bandiera italiana"
  ];

  /* ==========================================================
     RICONOSCIMENTO NUOVI CIONDOLI
     ========================================================== */

  function isNewCharm(charm) {
    if (!charm) return false;

    var name = String(charm.name || "").trim();

    return NEW_CHARMS.indexOf(name) !== -1;
  }

  /* ==========================================================
     RICONOSCIMENTO INCISIONI
     ========================================================== */

  function isEngravedCharm(charm) {
    if (!charm) return false;

    if (charm.type === "engraved") {
      return true;
    }

    var url = String(charm.overlay || "");

    return /\/picture[_-]/i.test(url);
  }

  /* ==========================================================
     DIMENSIONI INCISIONI
     ========================================================== */

  function engravedScale(charm) {
    var url = String(charm.overlay || "");

    if (/picture_48_/i.test(url)) {
      return 0.75;
    }

    if (
      /picture_52_/i.test(url) ||
      /picture_23_/i.test(url)
    ) {
      return 0.65;
    }

    return 0.55;
  }

  /* ==========================================================
     SCALA DEL CIONDOLO
     ========================================================== */

  function charmScale(charm, geometry) {
    var base;

    if (isEngravedCharm(charm)) {
      base = engravedScale(charm);
    } else if (isNewCharm(charm)) {
      base = NEW_CHARM_SCALE;
    } else {
      base = 1;
    }

    if (!geometry.isMini) {
      return base;
    }

    /* Le incisioni conservano la dimensione originale */

    if (isEngravedCharm(charm)) {
      return base;
    }

    if (isNewCharm(charm)) {
      return base * MINI_NEW_SCALE;
    }

    return base * MINI_ORIGINAL_SCALE;
  }

  /* ==========================================================
     RISOLUZIONE PRESET E CHAIN TUNING
     ========================================================== */

  function resolve(presetName, tuning) {
    var name = String(presetName || "maxi")
      .trim()
      .toLowerCase();

    var geometry = Object.assign(
      {},
      PRESETS[name] || PRESETS.maxi
    );

    if (typeof tuning === "string" && tuning.trim()) {
      try {
        tuning = JSON.parse(tuning);
      } catch (error) {
        console.warn(
          "[LLNecklace] Chain tuning non valido",
          error
        );

        tuning = null;
      }
    }

    if (
      tuning &&
      typeof tuning === "object" &&
      !Array.isArray(tuning)
    ) {
      Object.assign(geometry, tuning);
    }

    geometry.isMini = name === "mini";

    return geometry;
  }

  /* ==========================================================
     CURVA DELLA CATENA
     ========================================================== */

  function chainY(g, distance) {
    var d2 = distance * distance;

    return (
      g.centerY -
      g.curveA * d2 -
      g.curveB * d2 * d2
    );
  }

  /* ==========================================================
     PENDENZA DELLA CATENA
     ========================================================== */

  function chainSlope(g, distance) {
    return -(
      2 * g.curveA * distance +
      4 * g.curveB *
      distance * distance * distance
    );
  }

  /* ==========================================================
     DISTANZA LUNGO LA CATENA
     ========================================================== */

  function offsetForArc(g, arc) {
    var sign = arc < 0 ? -1 : 1;
    var target = Math.abs(arc);

    var distance = 0;
    var length = 0;
    var step = 0.05;

    while (length < target && distance < 45) {
      var slope = chainSlope(
        g,
        distance + step / 2
      );

      length += step * Math.sqrt(
        1 + slope * slope
      );

      distance += step;
    }

    return sign * distance;
  }

  /* ==========================================================
     POSIZIONAMENTO DEI CIONDOLI
     ========================================================== */

  function layout(g, count, isMobile) {
    var width = isMobile
      ? g.charmWidthM
      : g.charmWidth;

    var spacing = g.linkPitch * g.linksBetween;

    var items = [];

    for (var i = 0; i < count; i++) {
      var arc = (
        i - (count - 1) / 2
      ) * spacing;

      var distance = offsetForArc(g, arc);

      items.push({
        arc: arc,

        x: g.centerX + distance,

        y: chainY(g, distance),

        tilt:
          -Math.atan(chainSlope(g, distance)) *
          (180 / Math.PI) *
          g.tilt
      });
    }

    return {
      charmWidth: width,
      items: items
    };
  }

  /* ==========================================================
     AGGANCIO ORIGINALE

     Utilizzato per le collane MAXI e come fallback MINI.
     ========================================================== */

  function originalAnchor(charm) {
    if (
      isEngravedCharm(charm) ||
      isNewCharm(charm)
    ) {
      return 8;
    }

    return 50;
  }

  /* ==========================================================
     RICONOSCIMENTO DEL PUNTO DI AGGANCIO PNG

     Legge i pixel visibili della PNG.

     Individua il primo bordo superiore non trasparente
     e lo usa come riferimento per l'aggancio.

     Utilizzato soltanto per la catena MINI.
     ========================================================== */

  var anchorCache = {};

  function readPngAnchor(url, callback) {
    if (
      Object.prototype.hasOwnProperty.call(
        anchorCache,
        url
      )
    ) {
      callback(anchorCache[url]);
      return;
    }

    var probe = new Image();

    probe.crossOrigin = "anonymous";

    probe.onload = function () {
      try {
        if (
          !probe.naturalWidth ||
          !probe.naturalHeight
        ) {
          throw new Error("Immagine non valida");
        }

        var w = Math.min(
          probe.naturalWidth,
          350
        );

        var h = Math.max(
          1,
          Math.round(
            probe.naturalHeight *
            w / probe.naturalWidth
          )
        );

        var canvas = document.createElement(
          "canvas"
        );

        canvas.width = w;
        canvas.height = h;

        var context = canvas.getContext(
          "2d",
          { willReadFrequently: true }
        );

        if (!context) {
          throw new Error("Canvas non disponibile");
        }

        context.drawImage(
          probe,
          0,
          0,
          w,
          h
        );

        var pixels = context.getImageData(
          0,
          0,
          w,
          h
        ).data;

        var first = h;
        var last = -1;

        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var alpha =
              pixels[(y * w + x) * 4 + 3];

            if (alpha > 35) {
              if (y < first) first = y;
              if (y > last) last = y;
            }
          }
        }

        if (last < first) {
          throw new Error(
            "PNG senza pixel visibili"
          );
        }

        var value = (
          first +
          (last - first) * 0.045
        ) / h * 100;

        value = Math.min(
          95,
          Math.max(0, value)
        );

        anchorCache[url] = value;

        callback(value);

      } catch (error) {
        anchorCache[url] = null;
        callback(null);
      }
    };

    probe.onerror = function () {
      anchorCache[url] = null;
      callback(null);
    };

    probe.src = url;
  }

  /* ==========================================================
     DISEGNO DEI CIONDOLI
     ========================================================== */

  function paint(
    layer,
    charms,
    geometry,
    isMobile
  ) {
    if (!layer) return;

    layer.innerHTML = "";

    charms = charms || [];

    var positions = layout(
      geometry,
      charms.length,
      isMobile
    );

    charms.forEach(function (charm, i) {
      if (!charm || !charm.overlay) return;

      var pos = positions.items[i];

      if (!pos) return;

      var width =
        positions.charmWidth *
        charmScale(charm, geometry);

      var image = document.createElement(
        "img"
      );

      /* IMMAGINE E DESCRIZIONE */

      image.alt = charm.name || "";

      image.style.position = "absolute";
      image.style.width = width + "%";
      image.style.maxWidth = "none";
      image.style.height = "auto";

      /* POSIZIONE ORIZZONTALE */

      image.style.left =
        "calc(" +
        pos.x +
        "% - " +
        width / 2 +
        "%)";

      /* POSIZIONE VERTICALE */

      var finalY = pos.y;

      if (geometry.isMini) {
        finalY -= MINI_CHARM_LIFT;
      }

      image.style.top = finalY + "%";

      /* COLORE */

      image.style.filter = isEngravedCharm(charm)
        ? "none"
        : NORMAL_CHARM_FILTER;

      /* SOVRAPPOSIZIONE CIONDOLI */

if (geometry.isMini) {

  /* I ciondoli piccoli devono stare davanti.
     In caso di dimensioni uguali,
     prevale la posizione nella selezione. */

  var scale = charmScale(charm, geometry);

  var sizePriority = Math.round(
    (10 - scale) * 10000
  );

  image.style.zIndex =
    sizePriority + i;

} else {

  /* Mantiene la gestione originale
     delle altre collane */

  image.style.zIndex = Math.max(
    1,
    100 - Math.round(Math.abs(pos.arc))
  );

}

      /* FUNZIONE PER ALLINEARE L'OCCHIELLO */

      function setAnchor(percent) {
        if (image.parentNode !== layer) {
          return;
        }

        image.style.transform =
          "translateY(-" +
          percent +
          "%) rotate(" +
          pos.tilt +
          "deg)";
      }

      /* POSIZIONE INIZIALE DI SICUREZZA */

      setAnchor(originalAnchor(charm));

      layer.appendChild(image);

      image.src = charm.overlay;

      /* ======================================================
         CORREZIONE AUTOMATICA SOLO MINI
         ====================================================== */

      if (geometry.isMini) {
        var explicit = Number(charm.anchorY);

        if (
          charm.anchorY !== undefined &&
          charm.anchorY !== null &&
          charm.anchorY !== "" &&
          isFinite(explicit)
        ) {
          setAnchor(
            Math.max(
              0,
              Math.min(95, explicit)
            )
          );

        } else {
          readPngAnchor(
            charm.overlay,
            function (value) {
              if (value !== null) {
                setAnchor(value);
              }
            }
          );
        }
      }
    });
  }

  /* ==========================================================
     FUNZIONI PUBBLICHE
     ========================================================== */

  return {
    PRESETS: PRESETS,
    resolve: resolve,
    layout: layout,
    paint: paint
  };

})();
